<template>
    <div>
        <div class="warp">
            <!-- 查询条件 -->
            <div class="retrieve border" ref="condition">
                <div class="left">
                    <div class="child">
                        <span class="name">问题状态</span>
                        <el-select v-model="sendInfo.opinionType" placeholder="请选择" size="small" clearable>
                        <el-option label="全部" :value="void 0"></el-option>
							<el-option
                            v-for="item in status"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">处理结果</span>
                        <el-select v-model="sendInfo.disposeStatus" placeholder="请选择" size="small" clearable>
                        <el-option label="全部" :value="void 0"></el-option>
							<el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                         size="small"
						v-model="sendInfoOne.time"
                         format="yyyy-MM-dd HH:mm:ss"
						value-format="yyyy-MM-dd HH:mm:ss"
						type="datetimerange"
						:default-time="['24:00:00','23:59:59']"
                         range-separator="至"
                         start-placeholder="开始日期"
                         end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    
                    <el-button type="primary" size="small" @click="retrieval" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
                <div class="right">
                </div>
            </div>
            <!-- 表格 -->
            <el-table
                :data="tableData"
                :default-sort="{prop: 'date'}"
                 ref="table"
                fit
                :height="bHeight"
                @sort-change="sortChange"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="opExplain"
                    show-overflow-tooltip
                    label="意见描述">
                </el-table-column>
                <el-table-column
                    prop="opinionType"
                    show-overflow-tooltip
                    label="问题分类">
                    <template slot-scope="{row}">
                      {{row.opinionType === 1?'建议':row.opinionType === 2?'问题':''}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="issueAccount"
                    show-overflow-tooltip
                    label="发布账号">
                </el-table-column>
                <el-table-column
                    prop="phone"
                    show-overflow-tooltip
                    label="联系电话">
                </el-table-column>
                <el-table-column
                    prop="disposeStatus"
                    show-overflow-tooltip
                    label="处理结果">
                    <template slot-scope="{row}">
                      {{row.disposeStatus === 0?'未处理':row.disposeStatus === 1?'已处理':''}}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    sortable
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
                    width="150">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain
                                   @click="check(scope.row)">详情</el-button>
                        <el-button v-if="!scope.row.disposeStatus" size="small" type="primary" class="super" plain
                                     @click="edit(scope.row)">处理</el-button>
                        
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <Paging
                :PageData="PageData"
                v-if="tableData.length>0"
                @nextpage="nextpage"
                @previouspage="previouspage"
                @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange"
                ></Paging>
            </div>
        </div>
        <el-dialog
                title="意见处理"
                :visible.sync="dialogInfo"
                width="30%">
                <div class="forms">
                    <div class="childTextarea">
                        <div class="name">意见反馈：</div>
                        <div class="content"><el-input type="textarea" v-model="sendInfoTwo.describe" show-word-limit maxlength="300" style="max-width:100%;"></el-input></div>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.describe']">错误提示：{{errors['sendInfoTwo.describe']}}</div>
                    <div class="doubleBtn" style="justify-content:flex-end">
                        <el-button size="small" @click="cancel">取消</el-button>
                        <el-button size="small" type="primary" @click="submit">确认</el-button>
                    </div>
                </div>
            </el-dialog>
    </div>
</template>

<script>
// import breadcrumb from '../../components/breadcrumb';
import Paging from '../../components/Paging';
import {getDict} from "@/axios";
export default {
    components:{
        // breadcrumb,
        Paging
    },
    data(){
        return{
            loading:false,
            bHeight: void 0,
            authorities:JSON.parse(window.localStorage.getItem('authorities')),
			status:[{name:'建议',value:1},{name:'问题',value:2}],
      //上下架
            options: [{
                value: '2',
                label: '中介服务名称'
                }, {
                value: '3',
                label: '发布账号'
            }, {
                value: '4',
                label: '更新账号'
            }],//检索下拉
            sendInfoOne:{
                time:"",//日期
                drop:'',//检索下拉值
                dropValue:"",//检索输入值
            },//检索提交数据
            tableData:[],//表格数据
			sendInfo:{
				currentPage:1,//当前页
				pageSize:10,//页条数
        opinionType: void 0,
        disposeStatus: void 0, // 处理状态：0=未处理，1=已处理,不传查询全部
        endDate:null,//结束时间
				startDate:null,//开始时间
        name:null,//姓名
				property:null,//排序字段
				direction: 'DESC', //排序排序方式DESC降 ASC升
				userName:null,//账号
				
			},
			PageData:{
			  currentPage: 0,
			  total: 0, //多少條
			},
			dataInfo:'',//详细信息
			statusList:[{name:'已处理',value:1},{name:'未处理',value:0}],
      dialogInfo:false,
      sendInfoTwo:{
        describe: void 0,
        id: void 0
      }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
    vuerify: {
        'sendInfoTwo.describe':{
            test:function(val){
                if(val){
                    return true;
                }else{
                    return false;
                }
            },
            message:'请填写意见说明'
        }
    },
	created() {
		// getDict('UA_LS').then(data=>{
		//     this.status = data.UA_LS;
		// })
		// this.$axiosz.get('/rpc/sysDict/parentId/1069409909080064').then(res=>{
		//     if(res.code==200){
		// 		this.statusList=res.data
		//     }else{
		//         this.$alert(res.msg)
		//     }
		// })
		this.getList()
	},
  mounted(){
    const that = this
    let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh =  44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 25
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
  },
    methods:{
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
		getList(){
      this.loading = true
			this.$axiosc.post('/backstage/opinion/opinionList',this.$qs.stringify(this.sendInfo)).then(res=>{
          this.loading = false
			    if(res.code==200){
			        this.tableData=res.data.content;
			        this.PageData.currentPage =res.data.currentPage; //当前页
			        this.PageData.total =res.data.totalElements;
			    }else{
			        this.$alert(res.msg)
			    }
			}).catch(e=>{
        this.loading = false
      })
		},
        //查询
        retrieval:function(){
			let lookData=this.sendInfoOne;
			if(lookData.time&&lookData.time.length>0){
				this.sendInfo.startDate=lookData.time[0];
				this.sendInfo.endDate=lookData.time[1];
			}else {
                this.sendInfo.startDate=null;
                this.sendInfo.endDate=null;
            }
            this.sendInfo.id=null;
            this.sendInfo.userName=null;
            this.sendInfo.name=null;
            this.sendInfo.intermediaryName=null;
            switch(lookData.drop){
                case '1':
                  this.sendInfo.id=lookData.dropValue;
                break;
                case '2':
                  this.sendInfo.intermediaryName=lookData.dropValue;
                break;
                case '3':
                  this.sendInfo.userName=lookData.dropValue;
                break;
                case '4':
                  this.sendInfo.updateUserName=lookData.dropValue;
                break;
            }
			// 检索值
			this.getList()
		},
        //表格排序事件
            sortChange: function ({column, prop, order}) {
                if (order == 'ascending') {
                    order = 'ASC';
                } else {
                    order = 'DESC';
                }
                this.sendInfo.property = prop;
                this.sendInfo.direction = order;
                this.getList();
            },
        //表格查看按钮
        check:function(row){
            this.$router.push({path:`/feedbackManagement/detail/${row.id}`,query:{index:'/feedbackManagement'},params:{id:row.id}})
        },
        //处理
        edit:function(row){
          this.sendInfoTwo.id = row.id ||  void 0
          this.sendInfoTwo.describe = void 0
          this.dialogInfo = true
            // if(row){//编辑
            //     this.$router.push({path:'/agentManagement/edit',query:{id:row.id,index:'/agentManagement'}})
            // }else{//发布
            //     this.$router.push({path:'/agentManagement/add',query:{index:'/agentManagement'}})
            // }
        },
        //表格下架,上架按钮
        soldOut:function(row){
		    let btnValue=row.btnValue;
            this.$confirm(`确认${btnValue}？`, btnValue, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axiosc.put('/backstage/intermediary/shelf/obtained/'+row.id).then((r)=>{
                        if(r.code==200){
                            this.$message({
                                type: 'success',
                                message: btnValue+'成功!'
                            });
                            this.getList();
                        }else{
                            this.$alert(r.msg);
                        }
                    })
                }).catch(() => {
            });
        },
        // 下一頁
        nextpage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        // 上一頁
        previouspage(val) {
          this.sendInfo.currentPage=val;
          this.getList();
        },
        handleSizeChange(val) {
          this.sendInfo.pageSize = val;
          this.getList()
        },
        handleCurrentChange(val) {
          this.sendInfo.currentPage = val;
          this.getList()
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogInfo=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axiosc.post('/backstage/opinion/dispose',this.$qs.stringify(this.sendInfoTwo)).then(res=>{
                    if(res.code == 200){
                        this.getList()
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        });
                        this.dialogInfo=false
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            }
        },
        onReset(){
          const param = {
            currentPage:1,//当前页
            pageSize:10,//页条数
            opinionType: void 0,
            disposeStatus: void 0, // 处理状态：0=未处理，1=已处理,不传查询全部
            endDate:null,//结束时间
            startDate:null,//开始时间
            name:null,//姓名
            property:null,//排序字段
            direction: 'DESC', //排序排序方式DESC降 ASC升
            userName:null,//账号
          }
          this.sendInfo =  Object.assign(this.sendInfo,param)
          this.sendInfoOne.time = void 0
          this.getList()
        }
    },watch:{
		'sendInfoOne.drop': {
        handler(val, oldVal) {
         this.sendInfoOne.dropValue=''
        },
        deep: true
      }
	}
}
</script>
<style scoped="scoped" lang="scss" >
	.noclick{
		color: #DDDDDD;
		border: 1px solid #ddd;
    cursor:not-allowed;
    &:hover,&:active,&:focus{
      color:#DDDDDD;
      border: 1px solid #ddd;
    }
	}
</style>
